module.exports = __webpack_public_path__ + "static/reinventing-american-health-care-a3c73bb3029f175f1d9da6dd5d0697a0.jpg";